/* eslint-disable no-console */
/* eslint-disable max-len */
/* eslint-disable import/no-cycle */
/* eslint-diable import/namespace */
import React, { useContext, useEffect, useState } from 'react';
import { Button, Grid } from '@mui/material';
import RoContext, { CLRoContext } from './argo-input/contextcall';
import SemView from './semView';
// import { defaultModalOptions } from '../../shared/constantVariable';

const ButtonGrid = (props) => {
  const {
    handleCloseRoModal,
    inputOutputFlag,
    calculateFlowSheet,
    translateObject,
    roDetails,
    setokbuttonFormAutoSave,
    schematicViewFlag
  } = props;
  const [showSemView, setShowSemView] = useState(false);
  // const [modalOption, setModalOption] = useState(defaultModalOptions);

  const handleSaveRocontextTableData = useContext(RoContext);
  const handleSaveCLRoTableData = useContext(CLRoContext);

  const handleRoOkBtn = (str = '') => {
    // if (!getFeedName().includes('CLRO')) {
    if (!(roDetails.type === 'customnode_CLROpump')) {
      handleSaveRocontextTableData.handleSaveRoTableData(handleSaveRocontextTableData.rowData, !str);
    } else {
      handleSaveCLRoTableData.handleSaveCLRoTableData(handleSaveCLRoTableData.rowData, !str);
    }
    if (str === '') {
      setokbuttonFormAutoSave(true);
    } else if (str === 'apply') {
      calculateFlowSheet('calculate');
    }
  };
  const showSemanaticView = () => {
    setShowSemView(true);
  };
  const handleCloseSemView = () => {
    setShowSemView(false);
    // setModalOption({
    //   ...defaultModalOptions,
    //   visible: true,
    //   message: translateObject('Do you want to close the RO input page?'),
    //   onYes: () => setShowSemView(false),
    //   onNo: () => setModalOption(defaultModalOptions)
    // });
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <div className="bottom-button">
          <div>
            <Button
              size="small"
              variant="contained"
              className={`btn-auto-width sansW4SeLig M_Bold ${!inputOutputFlag ? 'Primary-Disabled Forground-Text-Disabled' : 'backgroud-primary-default forground-text-primary-inverse'}`}
              disabled={!inputOutputFlag}
              onClick={() => { handleRoOkBtn('apply'); }}
            >
              {translateObject('Apply')}
            </Button>
            {(roDetails.type === 'customnode_CLROpump') && (
              <Button
                style={{ marginLeft: 10 }}
                size="small"
                variant="contained"
                disabled={!schematicViewFlag}
                className={`btn-auto-width sansW4SeLig M_Bold ${!schematicViewFlag ? 'Primary-Disabled Forground-Text-Disabled' : 'backgroud-primary-default forground-text-primary-inverse'}`}
                onClick={() => showSemanaticView()}
              >
                {translateObject('Schematic view Diagram')}
              </Button>
            )}
          </div>
          <div>
            <Button
              variant="contained"
              size="small"
              className="btn-auto-width sansW4SeLig M_Bold Secondary-Default secoundary-text-color-Primary-default"
              style={{ width: '120px', marginRight: 15 }}
              onClick={handleCloseRoModal}>
              {translateObject('Cancel')}
            </Button>
            <Button
              size="small"
              variant="contained"
              className="btn-auto-width sansW4SeLig M_Bold backgroud-primary-default forground-text-primary-inverse"
              onClick={() => handleRoOkBtn()}
              style={{ width: '120px' }}>
              {translateObject('OK')}
            </Button>
          </div>
        </div>
      </Grid>
      {showSemView && (
        <SemView
          showSemView={showSemView}
          handleCloseSemView={handleCloseSemView}
          roDetails={roDetails}
        />
      )}
    </Grid>
  );
};

export default ButtonGrid;
